import React from 'react';
import { Tag } from 'components/Molecules';
import classes from './RequirementItem.module.scss';

export const RequirementItem = ({ requirement }) => {
  const { name, items = [] } = requirement;
  return (
    <div className={classes.container}>
      <span>
        <Tag className={classes.requirementType} color="success">
          <span className={classes.label}>{name}</span>
          <span className={classes.badge}>{items.length}</span>
        </Tag>
      </span>
      {items.map((item, index) => (
        <div className={classes.requirementItem} key={index}>
          <span>{item.itemName}</span>
          {item.isMandatory && <sup>*</sup>}
        </div>
      ))}
    </div>
  );
};
